import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  InvoiceSummaryDto,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}invoices/File/${COMMON_QUERY_PARAMS.FILE_ID}/opened`;

export interface GetOpenedInvoiceByFileQueryArgs {
  fileId: string;
}

export const getOpenedInvoiceByFileRequest = (
  payload: GetOpenedInvoiceByFileQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getOpenedInvoiceByFileQuery = async (
  payload: GetOpenedInvoiceByFileQueryArgs,
): Promise<BackResponse<InvoiceSummaryDto> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<InvoiceSummaryDto>>(
      getOpenedInvoiceByFileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getOpenedInvoiceByFileQuery;
